/*
  Analytics Helpers
*/

/**
 * Log an event with GTM. 
 * Adds an event to the dataLayer
 * that GTM knows how to log to GA.
 * @param {String} eventName name of event
 * @param {Object} properties Object of associated data
 */
export function gtmEvent(eventName, properties) {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ...properties, event: eventName });
  }
}

const segmentIsDefined = () => (typeof window !== 'undefined') && window.analytics;

/**
 * Identify a Segment user. Uses an auto-generated anonymous ID.
 * https://segment.com/docs/connections/spec/identify/
 * @param {object} [traits]
 */
export function segmentIdentifyAnonymous(traits) {
  if (segmentIsDefined()) {
    window.analytics.identify(traits);
  }
}

/**
 * Send an event to Segment
 * https://segment.com/docs/connections/spec/track/
 * @param {string} event
 * @param {object} [properties]
 */
export function segmentTrack(event, properties) {
  if (segmentIsDefined()) {
    window.analytics.track(event, properties);
  }
}

export default {
  gtmEvent,
  segmentIdentifyAnonymous,
  segmentTrack,
};
